module.exports = __webpack_public_path__ + "img/2.726e9114.svg";